import { FunctionalComponent, createContext, h } from 'preact';
import { StateUpdater, useContext, useState } from 'preact/hooks';
import { Category } from '@usercentrics/cmp-browser-sdk';

type CategoryContextType = {
  categories: Category[];
  setCategories: StateUpdater<Category[]>;
};

const initialValue = {
  categories: [] as Category[],
  /* eslint-disable-next-line */
  setCategories: () => {},
};

const CategoryContext = createContext<CategoryContextType>(initialValue);

export const CategoryContextProvider: FunctionalComponent = ({ children }) => {
  const [categories, setCategories] = useState(initialValue.categories);

  return <CategoryContext.Provider value={{ categories, setCategories }}>{children}</CategoryContext.Provider>;
};

export const useCategoryContext = (): CategoryContextType => {
  return useContext(CategoryContext);
};
